<template>
  <div class="d-flex flex-column justify-center align-center">
    <v-progress-circular :color="color" :size="size" indeterminate />
    <div v-if="label" v-text="label" class="ma-4 text--secondary" />
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: [Number, String],
      default: 36,
    },
    label: String,
  },
}
</script>
